import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateSimDialogComponent } from '../create-sim-dialog/create-sim-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { map, switchMap, tap } from 'rxjs/operators';
import { EMPTY, Observable, of } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from "@angular/material/sort";
import { CompaniesService } from "../../../services/companies.service";
import { Sim } from "../../../model/sim";
import { DialogsService } from "../../../services/dialogs.service";
import { SnackService } from "../../../services/snack.service";
import { GeneralItemDetailDialogComponent } from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { Router } from "@angular/router";
import { SimsService } from "../../../services/sims.service";
import { Constants } from "../../../utils/constants";
import { Box } from "../../../model/box";

@Component({
  selector: 'aw-list-sims',
  templateUrl: './list-sims.component.html',
  styleUrls: ['./list-sims.component.scss']
})
export class ListSimsComponent implements OnInit, AfterViewInit {

  public displayedColumns = [
    'identifier',
    'box',
    'expirationDate',
    'dataUsage',
    'maxDataUsable',
    'simOperator',
    'monthlyFee',
    'status',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  @ViewChild('paginatorSims') paginatorUsers!: MatPaginator;
  @Input() box?: Box;
  @Input() embeddedLayout = false;
  dataSource!: MatTableDataSource<Sim>;
  expandedSimElement?: Sim;
  roles = Constants.roles;
  entities = Constants.entities;
  boxStatuses = Constants.boxStatuses;
  private allSims$!: Observable<Sim[]>;

  constructor(
    public dialog: MatDialog,
    private companiesService: CompaniesService,
    private simsService: SimsService,
    private dialogsService: DialogsService,
    private snackService: SnackService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.allSims$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => {
            if (this.box)
              return this.simsService.getSim(this.box?.sim?.id).pipe(map(value => [value]));
            else
              return this.simsService.getAllSims();
          }),
          tap(x => {
            this.dataSource = new MatTableDataSource<Sim>(x);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allSims$.subscribe();
  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortSims(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {

      const index: string = event.active;

      if (event.active === 'box') {
        if (event.direction === 'asc') {
          return ('' + b.box?.identifier).localeCompare('' + a.box?.identifier);
        } else {
          return ('' + a.box?.identifier).localeCompare('' + b.box?.identifier);
        }
      }

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }

    });
  }

  details(company: Sim): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: company });
  }

  createSim(): void {
    this.disabled = true;
    this.dialog
      .open(CreateSimDialogComponent, { data: new Sim() })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allSims$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editSim(sim: Sim): void {
    this.disabled = false;
    this.dialog
      .open(CreateSimDialogComponent, { data: { sim: sim, creatingFromBox: false } })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allSims$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  deleteSim(sim: Sim): void {
    this.disabled = true;
    const id = sim.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete sim', `Are you sure you want to delete the sim "${sim.identifier}"?`)
      .pipe(
        switchMap((value) => value ? this.simsService.deleteSim(<number>sim.id) : EMPTY),
        switchMap(() => this.allSims$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Sim deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }


}
